// extracted by mini-css-extract-plugin
export default {"root":"HoldOnDialog_root__+VVjL","title":"HoldOnDialog_title__C9x52"};